export const TOGGLE_EXPERIENCE_BOOK = 'TOGGLE_EXPERIENCE_BOOK'
export const TOGGLE_EXPERIENCE_MODAL = 'TOGGLE_EXPERIENCE_MODAL'
export const SELECT_EXPERIENCE = 'SELECT_EXPERIENCE'
export const UPDATE_BASE_VENUE = 'UPDATE_BASE_VENUE'
